// extracted by mini-css-extract-plugin
export default {"table-body-row":"styles_table-body-row__PuDtw"};